// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";
import * as R from "ramda";

import type { UnifizeChatRoom } from "src/types";

import Icons from "src/icons";
import {
  Button,
  ModalBody,
  ModalFooter,
  VStack,
  HStack,
  RadioGroup,
  Radio,
  Text,
} from "@chakra-ui/react";
import * as colors from "src/styles/constants/colors";

import * as styles from "../styles";

type Props = {
  newVersion: ?string,
  setNewVersion: Function,
  versions: UnifizeChatRoom[],
  processTitle: string,
  selectNewVersion: Function,
  handleClose: Function,
};

const Editor = ({
  newVersion,
  setNewVersion,
  versions,
  processTitle,
  selectNewVersion,
  handleClose,
}: Props) => {
  return (
    <>
      <ModalBody {...styles.modalBody}>
        <RadioGroup value={newVersion} onChange={setNewVersion}>
          <VStack {...styles.radioOptions}>
            <Radio value="auto">
              <HStack {...styles.centerAlign}>
                <Text {...styles.normalText}>
                  {i18n.t(k.AUTO_SELECT_CURRENT_REVISION)}
                </Text>
                <Icons fill={colors.purple} type="currentRevision" />
              </HStack>
            </Radio>

            {versions.map((version) => (
              <Radio key={version.id} value={version.id} {...styles.radio}>
                <Text {...styles.normalText}>
                  {processTitle}{" "}
                  {`${i18n.t(k._7)}${version.autoNo || version.seqNo || ""}`}
                  {version.currentVersion && "C"}
                  {i18n.t(k._)} {version.title}
                </Text>
                <Text {...styles.versionComment}>{version.versionComment}</Text>
              </Radio>
            ))}
          </VStack>
        </RadioGroup>
      </ModalBody>

      <ModalFooter {...styles.modalFooter}>
        <Button
          variant="uBlueFilled"
          onClick={selectNewVersion}
          disabled={R.isNil(newVersion)}
        >
          {i18n.t(k.CONFIRM)}
        </Button>
        <Button variant="uSecondary" onClick={handleClose}>
          {i18n.t(k.BACK)}
        </Button>
      </ModalFooter>
    </>
  );
};

export default Editor;
